import { ApolloQueryResult, useQuery } from '@apollo/client';
import React from 'react';
import {
  FetchPaymentMethodsForTransactionAccountQuery,
  FetchPaymentMethodsForTransactionAccountQueryVariables,
  PaymentMethod,
  PaymentMethodType,
} from '@css-xp/graphtypes';
import { PaymentMethodSelectDetailsLine } from './payment-method-details-line';
/*// @ts-ignore */
import PaymentMethodIcon from '../../../assets/img/icon-payment-method.svg';
import { fetchPaymentMethodsForTransactionAccount } from './queries/fetch-payment-methods-for-transaction-account';
import { ColGroup, SearchResultsTable, TableBody, TableHead } from '../../../search-results-table';
import { OpenSidebarRow } from '../../../open-sidebar-row';
import { Icon } from '../../../icon';
import { PaymentMethodRequest } from '../../../common-sidebars/src/set-payment-method-sidebar';

export enum SIDEBAR {
  SET_CARD_PAYMENT_DEFAULT = 'setCardPaymentDefault',
}

interface PaymentMethodTableProps {
  transactionAccountId?: string;
  refetch?: () => Promise<ApolloQueryResult<unknown>>;
  submitAction?: (request: PaymentMethodRequest) => Promise<PaymentMethod>;
  invoiceGroupId?: string;
  label?: string;
  isPaymentOnTermsMethodAllowed?: boolean;
}
//doofensmirts
const columns = [
  {
    name: 'Details',
    customClassNames: 'col-30',
  },
  {
    name: 'Default method',
    customClassNames: 'col-20',
  },
  {
    name: '',
  },
];

const PaymentMethodsTable = ({
  transactionAccountId,
  refetch,
  submitAction,
  invoiceGroupId,
  label,
  isPaymentOnTermsMethodAllowed = true,
}: PaymentMethodTableProps) => {
  const { data, loading, error } = useQuery<
    FetchPaymentMethodsForTransactionAccountQuery,
    FetchPaymentMethodsForTransactionAccountQueryVariables
  >(fetchPaymentMethodsForTransactionAccount, {
    variables: {
      id: transactionAccountId || '',
    },
    skip: !transactionAccountId,
  });

  const hasNoResults = !loading && (!data || data?.transactionAccount.availablePaymentMethods?.totalCount === 0);
  const allPaymentMethods = data?.transactionAccount.availablePaymentMethods?.nodes;

  const invoiceGroups = data?.transactionAccount.availableInvoiceGroups?.nodes;

  // if on an invoice group get the defaultPaymentMethod so we can display a ✅
  const invoiceGroupDefaultPaymentMethod = invoiceGroups?.find((invoiceGroup) => invoiceGroup?.id === invoiceGroupId);

  const txaDefaultPaymentMethod =
    allPaymentMethods?.filter(function (paymentMethod) {
      return paymentMethod?.default;
    }) ?? [];

  const getDefaultPaymentMethod = invoiceGroupId
    ? invoiceGroupDefaultPaymentMethod?.defaultPaymentMethod
    : txaDefaultPaymentMethod && txaDefaultPaymentMethod.length > 0
    ? txaDefaultPaymentMethod[0]
    : null;

  // Show only Uniq Payment on terms method available and prefer to the one which is selected as default payment method in invoice group.
  const selectedPaymentOnTerm: any = [];
  const deferredPaymentMethod =
    allPaymentMethods
      ?.filter((paymentMethod: any) => paymentMethod.type === PaymentMethodType.DEFERRED)
      .map((paymentMethod: any) => {
        if (
          invoiceGroupDefaultPaymentMethod?.defaultPaymentMethod?.id &&
          invoiceGroupDefaultPaymentMethod?.defaultPaymentMethod?.id === paymentMethod.id
        ) {
          selectedPaymentOnTerm.push(paymentMethod);
        }
        return paymentMethod;
      }) ?? [];

  const cardPaymentMethod =
    allPaymentMethods?.filter((paymentMethod: any) => paymentMethod.type === PaymentMethodType.CARD) ?? [];

  let paymentMethods = [...selectedPaymentOnTerm, ...cardPaymentMethod];
  if (!selectedPaymentOnTerm.length && deferredPaymentMethod.length) {
    paymentMethods = [...[deferredPaymentMethod[0]], ...paymentMethods];
  }

  // TODO : FetchMore - current behavior is to fetch all. Need to understand pagination from CCP
  return (
    <SearchResultsTable
      id="payment-methods"
      isLoading={loading}
      error={error?.toString()}
      noResults={hasNoResults}
      heading={label}
      entityName="payment methods"
    >
      <ColGroup columns={columns} />
      <TableHead columns={columns} />
      <TableBody>
        {(paymentMethods ?? []).map((paymentMethod, index) => {
          // if on an invoice group you can set payment on terms as default
          return invoiceGroupId || paymentMethod?.type === 'CARD' ? (
            (!invoiceGroupId ||
              (invoiceGroupId && invoiceGroupDefaultPaymentMethod?.defaultPaymentMethod?.id === paymentMethod?.id)) && (
              <React.Fragment key={`search-result-${index}`}>
                <OpenSidebarRow
                  sidebar={SIDEBAR.SET_CARD_PAYMENT_DEFAULT}
                  payload={{
                    isPaymentOnTermsDisabled: !isPaymentOnTermsMethodAllowed,
                    paymentMethods,
                    transactionAccountId,
                    invoiceGroupId,
                    refetch,
                    submitAction,
                    currentDefaultPaymentMethod: getDefaultPaymentMethod,
                  }}
                  isSelected={false}
                >
                  <td>
                    {/*// @ts-ignore */}
                    <img src={PaymentMethodIcon} className="avatar medium not-round" />
                    <PaymentMethodSelectDetailsLine paymentMethod={paymentMethod} />
                  </td>
                  <td>{(invoiceGroupId || paymentMethod?.default) && <Icon type="success" size="small" />}</td>
                  <td />
                </OpenSidebarRow>
              </React.Fragment>
            )
          ) : (
            <tr key={`search-result-${index}`}>
              <td>
                {/*// @ts-ignore */}
                <img src={PaymentMethodIcon} className="avatar medium not-round" />
                <PaymentMethodSelectDetailsLine paymentMethod={paymentMethod} />
              </td>
              <td>{paymentMethod?.default && <Icon type="success" size="small" />}</td>
              <td />
            </tr>
          );
        })}
      </TableBody>
    </SearchResultsTable>
  );
};

export default PaymentMethodsTable;
